import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import useCoinFlip from '../useCoinFlip';
import { Coin, CoinContainer, CoinInside, Container } from './styles';

function CoinFlipMedia({ data }) {
  const boxRef = useRef();
  useCoinFlip(data, boxRef);

  return (
    <Container>
      <CoinContainer>
        <CoinInside ref={boxRef}>
          <Coin className="heads">
            {data.headsMedia && <img src={data.headsMedia} alt="heads" />}
          </Coin>
          <Coin className="tails">
            {data.tailsMedia && <img src={data.tailsMedia} alt="tails" />}
          </Coin>
        </CoinInside>
      </CoinContainer>
    </Container>
  );
}

CoinFlipMedia.propTypes = {
  data: PropTypes.shape({
    headsMedia: PropTypes.string,
    tailsMedia: PropTypes.string,
    mustSpin: PropTypes.bool,
    winner: PropTypes.string,
  }),
  styles: PropTypes.shape({}),
};

CoinFlipMedia.defaultProps = {
  data: {
    headsMedia:
      'https://overlayon.s3.eu-west-3.amazonaws.com/media-heads.png',
    tailsMedia:
      'https://overlayon.s3.eu-west-3.amazonaws.com/media-tails.png',
    mustSpin: false,
    winner: 'heads',
  },
  styles: {},
};

export default CoinFlipMedia;
